/**
 * Api errors related to real-Time STT
 */
export var RealTimeSttErrorCode;
(function (RealTimeSttErrorCode) {
    /**
     * The specified provider is not supported for real-time stt
     */
    RealTimeSttErrorCode["UnsupportedProvider"] = "real-time-stt/UnsupportedProvider";
    /**
     * The STT dialect is not supported by this provider
     */
    RealTimeSttErrorCode["UnsupportedDialect"] = "real-time-stt/UnsupportedDialect";
    /**
     * The real-time STT courtroom capacity for a court system is insufficient to perform the current request.
     * This can happen during the process of enabling real-time STT. Either increase the courtroom limit for this court
     * system or disable real-time STT for some courtrooms to free up capacity.
     */
    RealTimeSttErrorCode["InsufficientCourtroomCapacity"] = "real-time-stt/InsufficientCourtroomCapacity";
})(RealTimeSttErrorCode || (RealTimeSttErrorCode = {}));
